export const ACTURIS_INTEGRATION_FLAG = 'enable-acturis-integration';

export const CLIENT_CENTER_LIST_PATH = '/customers/acturis';

export const CLIENT_CENTER_DETAIL_PATH = '/customers/acturis/:id';

export const LEGACY_CUSTOMERS_LIST_PATH = '/customers/list';

export const NOT_PROVIDED = '—';
